import {
  AppBar, Badge, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle
  , IconButton, Slide, Toolbar, Typography, TextField, Avatar,
  Popover, CardHeader, Card, Divider, CardContent, CardActions, Grid
} from '@material-ui/core';
import { fade } from '@material-ui/core/styles';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import MenuIcon from '@material-ui/icons/Menu';
import MenuOpenIcon from '@material-ui/icons/MenuOpen';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import TrackChangesIcon from '@material-ui/icons/TrackChanges';
import { makeStyles, withStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import { connect } from 'react-redux';
import { useHistory } from 'react-router';
import MaterialOrder from 'src/components/MaterialOrder';
import NotificationsPopover from 'src/components/NotificationsPopover';
import PriceChangeList from 'src/components/PriceChangeList';
import { getNotifications, notifyNotificationViewed } from 'src/store/api/notificationsApi';
import axios from 'src/utils/axios';
import { getSepetAdet, getUser, handleLogoutMain, setSepetAdet } from 'src/utils/Common';
import { baseURL } from 'src/utils/contants';
import { closeAlert, getTasksRequest } from '../../store/actions';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import { useOktaAuth } from '@okta/okta-react';
const useStyles = makeStyles((theme) => ({
  root: {
    boxShadow: 'none',
  },
  table: {
    minWidth: 600
  },
  flexGrow: {
    flexGrow: 1
  },
  title: {
    flexGrow: 1,
    marginBottom: theme.spacing(-1),
    marginLeft: theme.spacing(5),
    fontFamily: 'AssistantRegular',
    color: '#FF9800'
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(1),
      width: 'auto',
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '12ch',
      '&:focus': {
        width: '20ch',
      },
    },
  },
  large: {
    width: theme.spacing(15),
    height: theme.spacing(15),
  },
}));
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const StyledBadge = withStyles((theme) => ({
  badge: {
    backgroundColor: "#44b700",
    color: "#44b700",
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "$ripple 1.2s infinite ease-in-out",
      border: "1px solid currentColor",
      content: '""'
    }
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0
    }
  }
}))(Badge);



function TopBar({ onOpenNavBar, className, getTasksRequest, alertReducer, closeAlert }) {
  const classes = useStyles();
  const history = useHistory();
  const notificationsRef = useRef(null);
  const [notifications, setNotifications] = useState([]);
  const [showNotificationList, setShowNotificationList] = useState(false);
  const [MenuShow, setMenuShow] = useState(false);
  const [sepetAdetDeger, setSepetAdetDeger] = useState(0);
  const [FiyatDegisiklikAdet, setFiyatDegisiklikAdet] = useState(0);
  const [openBasket, setopenBasket] = useState(false);
  const [openFiyatDegisiklik, setopenFiyatDegisiklik] = useState(false);
  const [Counting, setCounting] = useState(false);
  const [SepetData, setSepetData] = useState([]);
  const [FiyatData, setFiyatData] = useState([]);
  const [ChangeUser, setChangeUser] = useState(false);
  const [PopupChangeUser, setPopupChangeUser] = useState(false);
  const [UserIdParam, setUserIdParam] = useState('');
  const [expireTime, setExpireTime] = useState(null);
  const [TechnicianImage, setTechnicianImage] = useState('');
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const SessionUser = getUser();
  const { oktaAuth } = useOktaAuth();

  const handleClickNotification = ({ ID, Url }) => {
    setShowNotificationList(false);
    //notify server that was read
    notifyNotificationViewed(ID);
    getTasksRequest();
    if (Url.match(baseURL)) {
      history.push(Url.replace(baseURL, ''));
    } else {
      window.open(Url, '_blank');
    }
    //remove clicked notification
    setNotifications(notifications => notifications.filter(notification => notification.ID !== ID));
  };
  const handleCloseBasket = () => {
    setopenBasket(false);
  };
  const handleCloseFiyatDegisiklik = () => {
    setopenFiyatDegisiklik(false);
  };
  const handleCloseCounting = () => {
    setCounting(false);
  };
  const handleClosePopupChangeUser = () => {
    setPopupChangeUser(false);
  };

  var Deger = getSepetAdet();

  useEffect(() => {
    var Deger = getSepetAdet();
    setSepetAdetDeger(Deger);
    setTechnicianImage(localStorage.getItem('UserPhoto'));
    if (SessionUser.Info != "") {
      setCounting(true);
    }
    if (SessionUser.UserId.substring(0, 1) != 'Y') {
      setChangeUser(true);
    }
    var control = localStorage.getItem('okta-token-storage') || [];
    var timestamp = JSON.parse(control).accessToken.expiresAt

    var formatedDate = new Intl.DateTimeFormat('tr-TR', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(timestamp * 1000)
    setExpireTime(formatedDate);

  }, [Deger]);

  const handleDeleteAll = () => {
    setShowNotificationList(false)
    confirmAlert({
      message: "Tüm Bildirimleriniz Silinecektir. Onaylıyor Musunuz?",
      buttons: [
        {
          label: 'Evet',
          onClick: () => deleteYes()
        },
        {
          label: 'Hayır',
          onClick: () => { return; }
        }
      ]
    });
    const deleteYes = () => {
      notifications.forEach(e => {
        notifyNotificationViewed(e.ID);
      });
      getNotifications()
        .then(res => {
          res.data && setNotifications(res.data);
        })
        .catch(error => console.error(error));
    }
  }
  const setMenuShowFnc = () => {
    if (MenuShow) {
      setMenuShow(false);
    } else {
      setMenuShow(true);
    }
    onOpenNavBar();
  }

  const Beyaz = {
    color: '#FFFFFF'
  };




  const handleChangeUser = () => {
    if (UserIdParam === '') {
      alert("Lütfen geçiş yapmak istediğiniz servis kullanıcısının Y li kodunu giriniz!...");
      return;
    } else {
      axios.get(`/SetAdminChangeUser/${SessionUser.UserId}/${UserIdParam}`)
        .then(response => {
          setPopupChangeUser(false);
        })
        .catch(error => {
          setPopupChangeUser(false);
        });
    }


  }


  const SepetAc = () => {
    axios.get(`/GetMaterialOrderBasket/${SessionUser.ServiceShopId}/${SessionUser.TechnicianId}`)
      .then(response => {
        if (response.data.length > 0) {
          setSepetData(response.data);
          setSepetAdet(response.data.length);
          setopenBasket(true);
        } else {
          setSepetAdet(0);
          setSepetData([]);
          setopenBasket(true);
        }
      })
      .catch(error => {
        setSepetAdet(0);
        setSepetData([]);
      });
  }

  const OpenChangeUser = () => {
    setPopupChangeUser(true);
  }

  const FiyatDegisiklikAc = () => {
    axios.get(`/GetMaterialPriceChange/${SessionUser.ServiceShopId}/${SessionUser.TechnicianId}`)
      .then(response => {
        if (response.data.length > 0) {
          setFiyatData(response.data);
          setFiyatDegisiklikAdet(response.data.length);
          setopenFiyatDegisiklik(true);
        } else {
          setFiyatDegisiklikAdet(0);
          setFiyatData([]);
          setopenFiyatDegisiklik(true);
        }
      })
      .catch(error => {
        setFiyatDegisiklikAdet(0);
        setFiyatData([]);
        setopenFiyatDegisiklik(true);
      });
  };

  const Logout = async () => {
    handleLogoutMain();
    await oktaAuth.signOut();
  };

  return (
    <AppBar
      className={clsx(classes.root, className)}
      style={{ background: '#424242' }}
    >
      <Toolbar>
        <IconButton
          className={classes.menuButton}
          style={Beyaz}
          onClick={setMenuShowFnc}
          data-tour="OpenNavbarButton">
          {MenuShow ? <MenuIcon /> : <MenuOpenIcon />}
        </IconButton>
        <Typography
          variant="h4"
          component="h3"
          style={{ fontFamily: 'AssistantRegular', color: '#FF9800', paddingTop: 3 }}
        >
          Oasis
        </Typography>
        <IconButton style={{ flexGrow: 1 }} />

        {
          SessionUser.Info != "" ?
            <Typography
              variant="h4"
              component="h3"
              style={{ fontFamily: 'AssistantRegular', color: 'red', paddingTop: 3, paddingRight: 10 }}
            >

              {SessionUser.Info}
            </Typography>
            : ''
        }
        {
          ChangeUser ?
            <IconButton
              className={classes.iconButton}
              onClick={OpenChangeUser}
            >
              <Badge
                style={Beyaz}
              >
                <PeopleAltIcon color="primary" />
              </Badge>
            </IconButton>
            : ''
        }


        <IconButton
          className={classes.iconButton}
          onClick={SepetAc}
        >
          <Badge
            style={Beyaz}
            badgeContent={sepetAdetDeger}
          >
            <ShoppingCartIcon color="primary" />
          </Badge>
        </IconButton>
        <IconButton
          className={classes.iconButton}
          onClick={FiyatDegisiklikAc}
        >
          <Badge
            style={Beyaz}
            badgeContent={FiyatDegisiklikAdet}
          >
            <TrackChangesIcon color="primary" />
          </Badge>
        </IconButton>
        <IconButton
          className={classes.iconButton}
          onClick={() => setShowNotificationList(true)}
          ref={notificationsRef}
        >
          <Badge
            style={Beyaz}
            badgeContent={notifications.length}
          >
            <NotificationsActiveIcon color="primary" />
          </Badge>
        </IconButton>
        <StyledBadge
          overlap="circular"
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right"
          }}
          variant="dot"
          onClick={(event) => setAnchorEl(event.currentTarget)}
        >
          <Avatar
            alt="Person"
            src={TechnicianImage} />
        </StyledBadge>        
      </Toolbar>
      <NotificationsPopover
        anchorEl={notificationsRef.current}
        notifications={notifications}
        onClickNotification={handleClickNotification}
        onClose={() => setShowNotificationList(false)}
        open={showNotificationList}
        handleDeleteAll={handleDeleteAll}
      />
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={(e) => setAnchorEl(null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center"
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center"
        }}
      >
        <Card>
          <CardHeader title={
            <Typography component={'h6'}>
              {SessionUser?.ServiceShopCode + '-' + SessionUser?.ServiceShopName}
            </Typography>
          } />
          <Divider />
          <CardContent>
            <Grid contaniar spacing={2}>
              <Grid item xs={12} align="center">
                <Avatar alt="Person" src={TechnicianImage} className={classes.large} />
              </Grid>
              <Grid item xs={12} align="center">
                <br />
                <Typography component={'h6'}>
                  {SessionUser?.UserId + '-' + SessionUser?.FirstName + ' ' + SessionUser?.LastName}
                </Typography>
              </Grid>
              <Grid item xs={12} align="center">
                <Typography component={'h6'}>
                  {SessionUser?.MobileNumber}
                </Typography>
              </Grid>
            </Grid>

          </CardContent>
          <Divider />
          <CardActions>
            <Button
              variant="contained"
              color="secondary"
              fullWidth
              size="small"
              // onClick={handleLogoutMain} 
              onClick={() => Logout()}
              data-tour="LogoutButton"
              endIcon={<ExitToAppIcon>Stok</ExitToAppIcon>}
            >
              Çıkış Yap
            </Button>
          </CardActions>
        </Card>
      </Popover>
      <Dialog
        open={alertReducer.open}
        onClose={() => closeAlert()}
      >
        <DialogTitle color="primary">{alertReducer.title}</DialogTitle>
        <DialogContent>
          <DialogContentText >
            {alertReducer.message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => closeAlert()}
            color="primary">
            Tamam
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openBasket}
        maxWidth={'lg'}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleCloseBasket}      >
        <DialogTitle>
          Sipariş İçin Bekleyen Malzemeler Sepeti
        </DialogTitle>
        <DialogContent>
          <MaterialOrder SepetData={SepetData} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseBasket} color="primary">
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={Counting}
        maxWidth={'md'}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleCloseCounting}      >
        <DialogTitle>
          Depo Bilgilendirme
        </DialogTitle>
        <DialogContent>
          <Typography variant="h6" gutterBottom>
            {SessionUser.Info}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseCounting} color="primary">
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openFiyatDegisiklik}
        maxWidth={'md'}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleCloseFiyatDegisiklik}      >
        <DialogTitle>
          Son 3 Gün İçinde Fiyatı Değişen Malzemeler
        </DialogTitle>
        <DialogContent>
          <PriceChangeList FiyatData={FiyatData} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseFiyatDegisiklik} color="primary">
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={PopupChangeUser}
        maxWidth={'lg'}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClosePopupChangeUser}      >
        <DialogTitle>
          Yazacagınız Kullanıcı Gibi Davranacaktır!... (Örn: YXXXXX)
        </DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            value={UserIdParam}
            placeholder={'Yxxxxxx'}
            onChange={(e) => setUserIdParam(e.target.value)}
            variant="outlined" />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleChangeUser} color="primary">
            Değİştİr
          </Button>
          <Button onClick={handleClosePopupChangeUser} color="primary">
            Kapat
          </Button>
        </DialogActions>
      </Dialog>

    </AppBar>
  );
}

TopBar.propTypes = {
  className: PropTypes.string,
  onOpenNavBar: PropTypes.func
};

export default connect(
  state => ({ alertReducer: state.alertReducer }),
  {
    getTasksRequest, closeAlert
  }
)(TopBar);
